import { Grid } from '@material-ui/core';
import { EntityLayout } from '@backstage/plugin-catalog';
import { EntityUserProfileCard } from '@backstage/plugin-org';
import { CustomOwnershipCard } from '../cards/OwnershipCard';
import { entityWarningContent } from '../shared/tabs';

export const userPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}><EntityUserProfileCard variant="gridItem" /></Grid>
        <Grid item xs={12} md={6}><CustomOwnershipCard variant="gridItem" /></Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
